import Icon from '../assets/index'

export const ModalHeader = ({ title, onClose }) =>
  <header class='control-modal-header'>
    <div class='control-modal-header-title'>{title}</div>
    <button class='control-header-close' onClick={() => onClose()}>
      <Icon icon={'close'} />
    </button>
  </header>
